// IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы — обновление гридов): отложенное обновление скрытого грида (AttrGrid).
// Проба dev02 fe-2026-10-25-33: refresh() скрытого грида (вкладка не активна / прокручен за экран — v-visible) ставил need_refresh_afterTimeout, которого никто не читал:
// строки, добавленные / удалённые в записи, пока грид скрыт, не показывались и после открытия вкладки. Здесь — чистые функции: слияние аргументов отложенных refresh,
// снимок строк (тождество объектов, дерево childItemsPath) для сверки «скрыт ↔ показан» и решение при показе. Выключатель fe.ux.gridDeferredRefresh (§8, дефолт ВКЛ)
export const GDR_FLAG = 'fe.ux.gridDeferredRefresh'
export function gdrOn(setting) {
    try { return (typeof setting === 'function' ? setting(GDR_FLAG, true) : true) !== false } catch (e) { return true }
}
// аргументы отложенных refresh(items, modified, check_WHERE): строки для выделения — последнего вызова со строками, modified / check_WHERE — хотя бы одного; n — число вызовов
export function gdrMerge(prev, items = null, modified = true, check_WHERE = true) {
    const p = prev && typeof prev === 'object' ? prev : { items: null, modified: false, check_WHERE: false, n: 0 }
    return { items: Array.isArray(items) && items.length ? items : (p.items || null), modified: !!p.modified || !!modified, check_WHERE: !!p.check_WHERE || !!check_WHERE, n: (p.n || 0) + 1 }
}
const OPEN = Symbol('gdr<'), CLOSE = Symbol('gdr>')
export const GDR_SNAP_MAX = 20000
// снимок строк: объекты строк (raw — снятие реактивной обёртки) в порядке обхода, дети childItemsPath (имя или по уровням) — в скобках; не массив / больше max — null (сверки нет)
export function gdrSnap(data, childPath = '', raw = (x) => x, max = GDR_SNAP_MAX) {
    const top = data ? raw(data) : data
    if (!Array.isArray(top)) return null
    const out = []
    const pathAt = (d) => (Array.isArray(childPath) ? childPath[Math.min(d, childPath.length - 1)] : childPath)
    const walk = (arr, d) => {
        for (const it0 of arr) {
            if (out.length > max) return false
            const it = it0 && typeof it0 === 'object' ? raw(it0) : it0
            out.push(it)
            const cp = pathAt(d)
            const kids = cp && it && typeof it === 'object' && it[cp] ? raw(it[cp]) : null
            if (Array.isArray(kids) && kids.length && d < 32) {
                out.push(OPEN)
                if (!walk(kids, d + 1)) return false
                out.push(CLOSE)
            }
        }
        return true
    }
    return walk(top, 0) && out.length <= max ? out : null
}
// снимки одинаковы (нет снимка — сверять нечего: «одинаковы»)
export function gdrSame(a, b) {
    if (!Array.isArray(a) || !Array.isArray(b)) return true
    if (a.length !== b.length) return false
    for (let i = 0; i < a.length; i++) if (a[i] !== b[i]) return false
    return true
}
// решение при показе: отложенный refresh — его аргументы; без него — сверка снимка скрытия с текущими строками (now — массив или функция; данные пересобраны — не сверять):
// строки поменяли мимо грида — refresh без пометки «изменено» и без check_WHERE; иначе null
export function gdrShowPlan(pending, snap, now, rebuilt = false) {
    if (pending && typeof pending === 'object') return { why: 'pending', items: pending.items || null, modified: !!pending.modified, check_WHERE: !!pending.check_WHERE }
    if (!Array.isArray(snap) || rebuilt) return null
    const cur = typeof now === 'function' ? now() : now
    if (!Array.isArray(cur) || gdrSame(snap, cur)) return null
    return { why: 'stale', items: null, modified: false, check_WHERE: false }
}
export function gdrCount(k) {
    try { const s = (window.__gdrStats = window.__gdrStats || { deferred: 0, pending: 0, stale: 0 }); s[k] = (s[k] || 0) + 1 } catch (e) { /* без window (тесты) */ }
}
